import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d01d229"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memberItem" }
const _hoisted_2 = { class: "memberItem__name" }


const __default__ = {
  name: 'AddMemberItem'
}

import { NAvatar } from 'naive-ui'
import { Dismiss16Filled } from '@vicons/fluent'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    avatar: null,
    name: null
  },
  emits: ['deleteOnce'],
  setup(__props: any, { emit: emits }) {

const props = __props as { avatar: string; name: string }




return (_ctx: any,_cache: any) => {
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NAvatar), {
      round: "",
      src: props.avatar,
      size: 24,
      class: "memberItem__avatar"
    }, null, 8, ["src"]),
    _createVNode(_component_n_ellipsis, { style: {"max-width":"120px"} }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(props.name), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_n_button, {
      text: "",
      circle: "",
      class: "memberItem__deleteButton",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('deleteOnce')))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, { size: "15" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Dismiss16Filled), { color: "#9FA1A6" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})